<template>
  <main class="customer_join main" id="main_con" ref="main_con">
    <div class="join_inner" ref="join_inner">
      <div class="text_area">
        <h2>휴대폰 번호를<br />입력해 주세요.</h2>
        <p>입력하신 번호는 매장에게 공개되지 않아요!</p>
      </div>
      <div class="input_txt">
        <div class="input">
          <input
            id="mobileNum"
            placeholder="01012345678"
            type="number"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="11"
            v-model.trim="mobileNumber"
            @keyup="isMobileNumber"
          />
        </div>
        <p class="input_valid" :class="{ on: isError }">
          {{ errormsg }}
        </p>
      </div>
    </div>
    <div class="join_btn_area">
      <div class="btn_txt">
        <p>휴대폰 번호가 변경되셨나요?</p>
        <a @click="goEmailConfirmPage()">이메일로 불러오기</a>
      </div>
      <button @click="goJoinMobileAuth()">다음</button>
    </div>
  </main>
</template>
<script>
import { authMapActions, authTypes } from '@common/store/modules';

import { mapActions as userMapActions } from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import { isApp, checkMobileOperatingSystem } from '@common/lib/common/utils';

export default {
  name: 'joinMobile',
  components: {},
  data() {
    return {
      errormsg: null,
      isError: false,
      mobileNumber: '',
      isUserLoginPass: false,
    };
  },
  created() {},
  async mounted() {
    if (isApp() && checkMobileOperatingSystem() === 'iOS') {
      // 키보드가 생기거나 없어질때 처리
      window.visualViewport.onresize = this.changeheight;
    }
    var mobileNum = document.querySelector('#mobileNum');
    mobileNum.focus();
    const target = document.querySelector('#main_con');
    setTimeout(() => {
      target.scrollTo(0, 0);
    }, 10);
  },
  computed: {},
  methods: {
    ...authMapActions([authTypes.AUTH_REQ]),
    ...userMapActions([userTypes.FIND_USER_BY_MOBILE_NUMBER]),
    changeheight() {
      document.getElementById('body').scrollIntoView({ behavior: 'auto' });
      // let documentHeight = document.documentElement.clientHeight;
      // let viewportHeight = window.visualViewport.height;
      // let keyboardHeight = documentHeight - viewportHeight + 1;
    },
    goEmailConfirmPage() {
      this.$router.push({ name: 'Auth.EmailConfirm' });
    },
    isMobileNumber() {
      var mobileNum = document.querySelector('#mobileNum');
      let regExp = /^010|011|016|017|018|019|999\d{3,4}\d{4}$/;

      const mobileNumVal = mobileNum.value.trim();

      if (
        !regExp.test(mobileNumVal) ||
        !mobileNumVal.length ||
        (mobileNumVal.length !== 10 && mobileNumVal.length !== 11)
      ) {
        this.isError = true;
        this.errormsg = '휴대폰 번호를 정확히 입력 해주세요.';
        return false;
      } else {
        this.isError = false;
        this.errormsg = null;
        return true;
      }
    },
    goJoinMobileAuth() {
      if (!this.isMobileNumber()) {
        return false;
      }

      let mobileNumVal = this.mobileNumber.trim();

      const params = {
        inputValue: mobileNumVal,
        authType: 'SMS',
      };

      const pass_num = mobileNumVal.slice(0, 3);
      if (pass_num == '999') {
        this.isUserLoginPass = true;
        mobileNumVal = mobileNumVal.replace('999', '010');
      }

      // 인증번호 발송
      this[authTypes.AUTH_REQ](params)
        .then(msg => {
          if (mobileNumVal === '01012341234' || this.isUserLoginPass) {
            alert(msg.message);
          }

          localStorage.setItem('join_mobile', mobileNumVal);

          this.$router.push({
            name: 'Auth.JoinMobileAuth',
            params: { authSend: 'success' },
          });
        })
        .catch(err => {
          alert('인증번호 발송이 실패 하였습니다.');
        });
    },
  },
};
</script>
